import { Outlet, ScrollRestoration, type RouteObject } from 'react-router-dom'
import { NavBar } from '@/components/layout/NavBar'
import { PlayerProvider } from '@/components/player/PlayerProvider'
import { PlayerBar } from '@/components/player/PlayerBar'
import { Dashboard } from '@/components/dashboard/Dashboard'
import { InstructorPage } from '@/components/instructor/InstructorPage'
import { InstructorsListPage } from '@/components/instructor/InstructorsListPage'
import { ThemeDeepDivePage } from '@/components/instructor/ThemeDeepDivePage'
import { UnlicensedArtistsPage } from '@/components/instructor/UnlicensedArtistsPage'
import { AboutPage } from '@/components/about/AboutPage'
import { BuildPlaylistPage } from '@/components/build/BuildPlaylistPage'
import { NotFoundPage } from '@/components/layout/NotFoundPage'
import { usePageMeta } from '@/hooks/usePageMeta'

function Layout() {
  usePageMeta()

  return (
    <PlayerProvider>
      <NavBar />
      <Outlet />
      <PlayerBar />
      {/* Scrolls to top on a new page and restores position on back/forward. */}
      <ScrollRestoration />
    </PlayerProvider>
  )
}

// Shared by the browser (createBrowserRouter) and the server renderer
// (createStaticHandler). Keep the static paths in step with Seo::PageMeta.
export const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: '/', element: <Dashboard /> },
      { path: '/instructors', element: <InstructorsListPage /> },
      { path: '/instructors/:id', element: <InstructorPage /> },
      { path: '/instructors/:id/themes/:theme', element: <ThemeDeepDivePage /> },
      { path: '/unlicensed-artists', element: <UnlicensedArtistsPage /> },
      { path: '/build', element: <BuildPlaylistPage /> },
      { path: '/about', element: <AboutPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]
